import * as React from "react"
import { observer } from "mobx-react-lite"
import { Formik, FormikProps, FormikValues } from "formik"
import { FormControl } from "../form-control/form-control"
import { ScrollView, ViewStyle } from "react-native"
import { TxKeyPath } from "../../i18n"

const FORM_CONTROL: ViewStyle = {
  marginBottom: 4
}

export interface FormProps {
  initialValues?: Record<string, any>,
  initialErrors?: Record<string, any>,
  loading?: boolean,
  onSubmit: (values) => void,
  innerRef?: React.Ref<FormikProps<FormikValues>> | ((node) => void),
  parentScrollViewRef?: { current: ScrollView }

  colorScheme?: "light" | "dark",

  deleteOnMultipleTx?: TxKeyPath
  denyAddOnMultiple?: boolean
  addOnMultipleTx?: TxKeyPath
}

/**
 * Describe your component here
 */
export const Form = observer(function Form(props: FormProps) {
  const { initialValues = {}, onSubmit, innerRef, ...rest } = props

  return (
    <Formik
      initialValues={{
        username: '',
        password: '',
        ...initialValues
      }}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
      {({ handleChange, values }) => (
        <>
          <FormControl
            isRequired
            labelTx="loginForm.username"
            labelPreset="title3"
            inputProps={{
              testID: "jala:id/username-input",
              placeholderTx: "loginForm.usernamePlaceholder",
              value: values.username,
              onChangeText: handleChange('username')
            }}
            style={FORM_CONTROL}
          />
          <FormControl
            isRequired
            labelTx="loginForm.password"
            labelPreset="title3"
            inputProps={{
              testID: "jala:id/password-input",
              type: "password",
              placeholderTx: "loginScreen.password",
              value: values.password,
              onChangeText: handleChange('password')
            }}
            style={FORM_CONTROL}
          />
        </>
      )}
    </Formik>
  )
})

Form.displayName = 'Form'
